module.exports = __webpack_public_path__ + "img/copy-svgrepo-com.svg";